import Vue from 'vue'
import Router from 'vue-router'

// Eager loading sample
// import Trajectory from './views/Trajectory.vue'

Vue.use(Router)

// const emptyComp = { component: { render: h => h('router-view') } }
const BaseContainer = resolve => require(['./components/base/BaseContainer.vue'], resolve)

export default new Router({
    mode: 'history',
    // base: '/',
    routes: [
        {
            path: '/',
            name: 'base',
            component: BaseContainer,
            redirect: '/landing-page',
            children: [
                {
                    path: 'landing-page',
                    name: 'Landing Page',
                    component: resolve => require(['./components/LandingPage.vue'], resolve)
                },
                {
                    path: 'home',
                    name: 'Home',
                    component: resolve => require(['./components/Home.vue'], resolve)
                },
                {
                    path: 'package/:id',
                    name: 'Package',
                    component: resolve => require(['./components/GachaPackageDetail.vue'], resolve)
                },
                {
                    path: 'gacha-opening',
                    props: true,
                    name: 'Gacha Opening',
                    component: resolve => require(['./components/GachaOpening.vue'], resolve)
                },
                {
                    path: 'gacha-result',
                    props: true,
                    name: 'Gacha Result',
                    component: resolve => require(['./components/GachaResult.vue'], resolve)
                }
            ]
        },
    ]
})